import { StrictEffect, call, put, takeLatest } from 'redux-saga/effects';
import { requestHTML, TRIGGERNEXTOVERLAY } from '@vfde-fe/sails_core';
import { loadScript, loadStyleSheet } from './helper/loadExternalScripts';
import {
    INSURANCE_ACCORDION,
    INSURANCE_OVERLAY_NAME,
    PRELOAD_GIGAKOMBI_OVERLAY,
    TAUSCHBONUS_OVERLAY_NAME,
    TRADEIN_ACCODRION,
    TRADE_IN_OVERLAY_NAME,
} from './constant';
import { mountOverlayAccordion, showOverlay } from './components/Overlay';
import { trackTradeInOverlay } from 'Helper/tracking';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-fe/sails-constants';
import { OverlayActionDispatchers, overlayActionCreators } from './action';
import { AnyAction } from 'redux';

/**
 * Gets the content of the overlay and populates it
 *
 * @export {function} getOverlayContent
 *
 */
export function* getOverlayContent (action: AnyAction): Generator<StrictEffect> {
    const { url, name } = action;

    if (!url) {
        return;
    }

    try {
        const response = (yield call(requestHTML, url, {})) as string;
        yield call(showOverlay, response);
        yield put(overlayActionCreators.overlayLoaded());

        switch (name) {
            case INSURANCE_OVERLAY_NAME:
                yield call(mountOverlayAccordion, INSURANCE_ACCORDION);
                break;
            case TAUSCHBONUS_OVERLAY_NAME:
                yield call(mountOverlayAccordion, TRADEIN_ACCODRION);
                break;
            case TRADE_IN_OVERLAY_NAME:
                yield call(trackTradeInOverlay);
                break;
        }
    } catch (err) {
        yield put(overlayActionCreators.getOverlayContentFailed(err));
    }
}

/**
 * preloadGigaKombiOverlay
 */
export function* preloadGigaKombiOverlay (action: ReturnType<OverlayActionDispatchers['preloadGigaKombiOverlay']>): Generator<StrictEffect> {
    const { contentTarget, scriptTarget } = action;
    const options: any = {};
    const { gigakombiOverlay } =  window[ADDITIONAL_PAGE_OPTIONS].gigakombi.offerPrice;
    const htmlMarkup = (yield call(requestHTML, gigakombiOverlay, options)) as string;
    contentTarget.innerHTML = `<div>${htmlMarkup}</div>`;

    // Scripts are generated in gigakombiXSell repo
    loadScript('/simplicity/assets/js/sails.gigakombi-xsell-mobile.js', scriptTarget);
    loadStyleSheet('/simplicity/assets/css/sails.gigakombi-xsell-mobile.css', scriptTarget);
}

/**
 * Waits for TRIGGERNEXTOVERLAY action from core to call getAPI
 *
 * @export {function} overlaySaga
 *
 */
export default function* overlaySaga () {
    yield takeLatest(TRIGGERNEXTOVERLAY, getOverlayContent);
    yield takeLatest(PRELOAD_GIGAKOMBI_OVERLAY, preloadGigaKombiOverlay);
}
